// extracted by mini-css-extract-plugin
export var container = "CustomFooter-module__container___bw6I-";